import { useSearchParams } from "react-router-dom";
import { assetAllocationPages } from "@app/const/route.const";
import { ModuleMultiPeriodReturnReport } from "@app/pages/portfolioAnalysis/pdfMultiPeriodReturnReport/ModuleMultiPeriodReturnReport";

export const PdfAssetAllocationModuleMultiPeriodReturnReportPage = () => {
  const [searchParams] = useSearchParams();
  const { portfolioGroupId, moduleId, data1Id, data2Id } =
    assetAllocationPages.getPdfModuleMultiPeriodReturnReportParams(
      searchParams,
    );

  return (
    <ModuleMultiPeriodReturnReport
      portfolioGroupId={portfolioGroupId}
      moduleId={moduleId}
      footer="Asset Allocation"
      data1Id={data1Id}
      data2Id={data2Id}
    />
  );
};
